module.exports = "<!-- <div class=\"modal-header\">\n  <div class=\"modal-title\">Delete User</div>\n</div> -->\n\n<div class=\"modal-body\" style=\"font-size:18px\">\n  <div>Do you really want to delete {{user.name}} ({{user.email}})?</div>\n</div>\n\n<div class=\"modal-footer\">\n  <button class=\"btn btn-danger pull-right\" ng-click=\"$uibModalInstance.close()\" style=\"margin-left: 10px\">Yes</button>\n  <button class=\"btn btn-default pull-right\" ng-click=\"$uibModalInstance.dismiss()\">No</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/users/deleteUser.html
// module id = 55
// module chunks = 0